module.exports = __webpack_public_path__ + "img/icon-last.4317634a.png";